import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/account.svg
 */
const IconAccount: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12 0a12 12 0 00-8.572 20.399c.283.283.575.549.883.806.306.264.63.507.968.728a11.967 11.967 0 0013.44 0c.34-.22.662-.464.968-.728.31-.257.601-.523.883-.806A11.999 11.999 0 0012 0zm0 22.285a10.186 10.186 0 01-6.807-2.574 6.86 6.86 0 0113.612 0A10.182 10.182 0 0112 22.285zM9.427 9.428a2.573 2.573 0 115.143 0 2.573 2.573 0 01-5.142 0h-.001zm10.8 8.742a8.59 8.59 0 00-5.276-5.64 4.287 4.287 0 00-2.854-7.387 4.287 4.287 0 00-3.059 7.388 8.588 8.588 0 00-5.275 5.639 10.285 10.285 0 1116.456 0h.008z"
      fill="currentColor"
    />
  </svg>
);

export default IconAccount;
